import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2B3F6C",
      "fill-rule": "evenodd",
      d: "M14.028 1.04a1.856 1.856 0 0 0-2.619.001L5.818 6.62a2.5 2.5 0 0 0-.737 1.673l-.08 1.884a1.51 1.51 0 0 0 1.514 1.574H8.37a2.53 2.53 0 0 0 1.808-.76l5.547-5.684c.708-.723.7-1.88-.017-2.594zm-1.904.713a.844.844 0 0 1 1.19 0l1.68 1.67c.325.326.329.851.007 1.18l-1.114 1.138-2.884-2.87zm-1.835 1.83L6.532 7.33a1.5 1.5 0 0 0-.442 1.004l-.08 1.885a.504.504 0 0 0 .505.524H8.37c.409 0 .8-.164 1.085-.455l3.727-3.826z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#2B3F6C",
      "stroke-linecap": "round",
      "stroke-width": "1.125",
      d: "M14.75 8.75v3A3.75 3.75 0 0 1 11 15.5H5a3.75 3.75 0 0 1-3.75-3.75v-6A3.75 3.75 0 0 1 5 2h3"
    }, null, -1)
  ]))]))
}
export default { render: render }